import { ReactNode, createContext, useContext } from 'react';
import type { PartnerConfig } from '../config';

// The context holds the partner config for the current session. Resolution
// happens at app boot in src/index.js (via resolvePartner) and is passed in
// as a prop — this keeps the resolver out of React's rendering lifecycle and
// allows boot-time setup (e.g. Sentry tagging) to read partnerId before
// React mounts.
//
// `null` only appears when a consumer reads outside <BrandingProvider> —
// useBranding() throws on that to fail loudly in dev.
const PartnerCtx = createContext<PartnerConfig | null>(null);

type BrandingProviderProps = {
  config: PartnerConfig;
  children: ReactNode;
};

export const BrandingProvider = ({
  config,
  children,
}: BrandingProviderProps) => (
  <PartnerCtx.Provider value={config}>{children}</PartnerCtx.Provider>
);

export const useBranding = (): PartnerConfig => {
  const ctx = useContext(PartnerCtx);
  if (!ctx) {
    throw new Error('useBranding called outside <BrandingProvider>');
  }
  return ctx;
};
